import jwtDecode from "jwt-decode";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IToken } from "../service/interfaces/IToken";

export type ProtectedRouteProps = {
  outlet: JSX.Element;
};

export default function ProtectedRouteAuth({ outlet }: ProtectedRouteProps) {
  const navigate = useNavigate();

  useEffect(() => {
    const tokenString = localStorage.getItem("token");
    const token: IToken | null = tokenString ? JSON.parse(tokenString) : null;
    if (token) {
      try {
        const decodedToken = jwtDecode(token.access_token) as { exp: number };
        const isTokenExpired = Date.now() >= decodedToken.exp * 1000;
        if (!isTokenExpired) { 
          navigate("/reversal", { replace: true });
        }
      } catch {
        localStorage.removeItem("token");
        localStorage.removeItem("profile");     
        navigate("/", { replace: true });
      }
    } else {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return outlet;
}
